import React from "react"
import themeConfig from "../../configs/themeConfig"
import classnames from "classnames"
import { useLocation } from 'react-router-dom'
import VerticalLayout from "./VerticalLayout";
import FullpageLayout from "./FullpageLayout"

const DynamicLayout = ({ children, ...rest }) => {
  const location = useLocation();
  const layoutComp = location.pathname.startsWith('/meeting/') || location.pathname.startsWith('/template/') ? <FullpageLayout children={children}/>
    : <VerticalLayout children={children} location={location}/>;
  return (
      <React.Fragment>
          {layoutComp}
      </React.Fragment>
  )
}

export default DynamicLayout
